module.exports = __webpack_public_path__ + "media/images/exception_handler/lion-25b7251182893937c3db2f5054245e29.png";